import request from "../http/index";

// 列表
export async function FAQList(data = {}) {
  const res = await request.post("/api/cp/FAQ/List", data);
  return res.data;
}

// 详情
export async function FAQInfo(data = {}) {
  const res = await request.post("/api/cp/FAQ/Info", data);
  return res.data;
}

// 新增
export async function FAQAdd(data = {}) {
  const res = await request.post("/api/cp/FAQ/Add", data);
  return res.data;
}

// 修改
export async function FAQEdit(data = {}) {
  const res = await request.post("/api/cp/FAQ/Edit", data);
  return res.data;
}

// 删除
export async function FAQDelete(data = {}) {
  const res = await request.post("/api/cp/FAQ/Delete", data);
  return res.data;
}
